import React, { useEffect, useState } from 'react';

/** Founder's Edit sale — change this date to extend or end the countdown. */
const SALE_ENDS_AT = new Date('2026-08-24T23:59:59+05:30');

function pad(n) {
  return String(Math.max(0, n)).padStart(2, '0');
}

function remainingParts(now) {
  const ms = SALE_ENDS_AT.getTime() - now.getTime();
  if (ms <= 0) return null;
  const totalSec = Math.floor(ms / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;
  return { days, hours, minutes, seconds };
}

function Unit({ value, label }) {
  return (
    <span className="inline-flex flex-col items-center leading-none mx-0.5 align-middle">
      <span className="font-serif-display text-[12px] sm:text-[13px] tracking-normal tabular-nums">{pad(value)}</span>
      <span className="text-[7px] tracking-[0.14em] opacity-70 mt-0.5">{label}</span>
    </span>
  );
}

function Countdown() {
  const [parts, setParts] = useState(() => remainingParts(new Date()));

  useEffect(() => {
    const t = setInterval(() => setParts(remainingParts(new Date())), 1000);
    return () => clearInterval(t);
  }, []);

  if (!parts) return <span>sale ended</span>;

  return (
    <span className="inline-flex items-end gap-0.5">
      <Unit value={parts.days} label="D" />
      <span className="opacity-60 pb-[7px]">:</span>
      <Unit value={parts.hours} label="H" />
      <span className="opacity-60 pb-[7px]">:</span>
      <Unit value={parts.minutes} label="M" />
      <span className="opacity-60 pb-[7px]">:</span>
      <Unit value={parts.seconds} label="S" />
    </span>
  );
}

function PromoSegment() {
  return (
    <span className="inline-flex items-center gap-3 sm:gap-4 whitespace-nowrap px-8 sm:px-12">
      <span>Flat 10% off on all prepaid orders</span>
      <span className="opacity-40" aria-hidden>
        ·
      </span>
      <span className="inline-flex items-center gap-2">
        <span aria-hidden>✦</span>
        <span>Founder&apos;s Edit sale ends in</span>
        <Countdown />
        <span aria-hidden>✦</span>
      </span>
    </span>
  );
}

export default function AnnouncementBar() {
  return (
    <div className="bg-[#1A2332] text-[#F5EFE6] text-[10px] sm:text-[11px] tracking-[0.16em] sm:tracking-[0.2em] uppercase overflow-hidden h-10 sm:h-11 flex items-center">
      <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
        <PromoSegment />
        <PromoSegment />
        <PromoSegment />
        <PromoSegment />
      </div>
    </div>
  );
}
